// extracted by mini-css-extract-plugin
export default {"child":"wrapper_child__yy-qv","container":"wrapper_container__iI52X"};